
import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";
import { Template } from "./models/template.model";


export const NOMINATION_ENDPOINT = 'nomination';
export const NOMINATION_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(NOMINATION_ENDPOINT);


export const nominationStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}